var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    {
      ref: "titleWrapper",
      staticClass: "activity-subtitle mb-0 text-light-gray bold",
    },
    [
      _vm.email
        ? _c("span", { staticClass: "mr-2" }, [
            _vm._v("\n    " + _vm._s(_vm.email) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.boardName
        ? _c(
            "span",
            {
              staticClass: "mr-2",
              attrs: {
                "data-toggle": "tooltip",
                "data-original-title":
                  _vm.$tc("global.doorr.board", 1) + ": " + _vm.boardName,
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-columns",
                attrs: { "aria-hidden": "true" },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.coApplicants
        ? _c(
            "span",
            { staticClass: "mr-2" },
            [
              _c("avatar-tooltip", {
                ref: "avatarTooltip",
                staticClass: "d-inline-flex",
                attrs: {
                  "tooltip-data": _vm.coApplicants,
                  "visible-data": _vm.firstThreeCoapplicants,
                  placement: "top",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }